var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMessageGrayDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "95px",
    viewBox: "0 0 98 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMessageGrayDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Welcome-to-Messenger-Icon",
    transform: "translate(-747.000000, -612.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.717949,612 C823.493226,612 844.435897,629.052531 844.435897,651.668339 C844.435897,674.280927 823.493226,691.333458 795.717949,691.333458 C794.805529,691.333458 793.910952,691.283944 793.013536,691.236845 L792.95433,691.234027 L769.312518,706.756456 C769.067584,706.917879 768.784126,707 768.500667,707 C768.26141,707 768.019315,706.941227 767.801145,706.824085 C767.322632,706.568866 767.024575,706.070909 767.024575,705.534306 L767.024575,684.653902 C754.100654,677.982801 747,666.302736 747,651.668339 C747,629.052531 767.942672,612 795.717949,612 Z M777,646 C774.238576,646 772,648.238576 772,651 C772,653.761424 774.238576,656 777,656 C779.761424,656 782,653.761424 782,651 C782,648.238576 779.761424,646 777,646 Z M795.5,646 C792.738576,646 790.5,648.238576 790.5,651 C790.5,653.761424 792.738576,656 795.5,656 C798.261424,656 800.5,653.761424 800.5,651 C800.5,648.238576 798.261424,646 795.5,646 Z M814,646 C811.238576,646 809,648.238576 809,651 C809,653.761424 811.238576,656 814,656 C816.761424,656 819,653.761424 819,651 C819,648.238576 816.761424,646 814,646 Z",
    id: "icMessageGrayDesktop"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessageGrayDesktop);
export default __webpack_public_path__ + "static/media/icMessageGrayDesktop.3dea1af614f28f157bfeacbbc560030f.svg";
export { ForwardRef as ReactComponent };